/* eslint-disable react/prop-types */
'use client'
import dynamic from 'next/dynamic'

import { RaHeading, RaRichText } from '@components/core/index.core'

import styles from './ra-footer-contact.module.scss'

const RaPortal = dynamic(() =>
  import('@components/features/RaPortal/RaPortal').then(({ RaPortal }) => RaPortal),
)

export const RaFooterContactPortal = ({ icon }) => {
  return (
    <div className={styles['ra-footer-contact__portal']}>
      <RaPortal color="dark">
        <div className={styles['ra-footer-contact__portal__content']}>
          <RaHeading
            alignment="center"
            component="h3">
            {icon.title}
          </RaHeading>
          <RaRichText
            className={styles['ra-footer-contact__portal__richtext']}
            content={icon.text}
          />
        </div>
      </RaPortal>
    </div>
  )
}
